// Russian Language Pack
export default {
  // 检测部位
  part: {
    '车头': 'Передняя часть',
    '发动机舱': 'Моторный отсек',
    '左前车身': 'Передняя левая часть кузова',
    '左前内饰': 'Передний левый салон',
    '左后车身': 'Задняя левая часть кузова',
    '左后内饰': 'Задний левый салон',
    '车尾': 'Задняя часть',
    '后备箱内部': 'Внутренняя часть багажника',
    '右后车身': 'Задняя правая часть кузова',
    '右后内饰': 'Задний правый салон',
    '右前车身': 'Передняя правая часть кузова',
    '右前内饰': 'Передний правый салон',
    '机电': 'Электрооборудование и механика',
    '新能源检测': 'Проверка автомобиля с электроприводом',
    '骨架': 'Каркас кузова',
    '外观': 'Кузов и экстерьер',
    '内饰': 'Салон',
    '其它': 'Прочее',
    '其他': 'Прочее',
    '水渍残留点': 'Следы воды',
  },

  // 损伤等级颜色
  damageLevel: {
    '轻微损伤': 'Незначительное повреждение',
    '严重损伤': 'Значительное повреждение',
    '预检异常': 'Аномалия предварительной проверки',
  },

  // 评分说明
  scoreRemark: {
    '车辆结构件与加强件均无因事故造成的损伤': 'Отсутствуют повреждения силовых и усилительных элементов кузова, вызванные ДТП.',
    '车辆结构件无因事故造成的损伤，车辆加强件有因事故造成的轻微损伤': 'Силовые элементы кузова без повреждений от ДТП; усилительные элементы имеют незначительные повреждения от ДТП.',
    '车辆结构件无因事故造成的损伤，车辆加强件有因事故造成的严重损伤': 'Силовые элементы кузова без повреждений от ДТП; усилительные элементы имеют значительные повреждения от ДТП.',
    '车辆结构件有因事故造成的损伤': 'Имеются повреждения силовых элементов кузова, вызванные ДТП.',
    '外观极差': 'Очень плохое состояние кузова',
    '内饰极差': 'Очень плохое состояние салона',
    '外观较差': 'Плохое состояние кузова',
    '内饰较差': 'Плохое состояние салона',
    '外观一般': 'Среднее состояние кузова',
    '内饰一般': 'Среднее состояние салона',
    '外观较好': 'Хорошее состояние кузова',
    '内饰较好': 'Хорошее состояние салона',
    '外观准新': 'Состояние кузова как новый',
    '内饰准新': 'Состояние салона как новый',
  },

  // 检测项名称
  inspectionItem: {
    '左前大灯': 'Левая передняя фара',
    '左前雾灯': 'Левая передняя противотуманная фара',
    '前底盘': 'Переднее днище',
    '前保险杠': 'Передний бампер',
    '中网': 'Решётка радиатора',
    '发动机舱盖外侧': 'Наружная сторона капота',
    '发动机舱盖内侧': 'Внутренняя сторона капота',
    '水箱框架': 'Радиаторная рамка',
    '前防撞梁': 'Передняя балка бампера',
    '左前纵梁': 'Левая передняя лонжерон',
    '左前翼子板骨架': 'Левая передняя арка крыла',
    '左前减震器支座': 'Левая передняя опора амортизатора',
    '防火墙': 'Перегородка моторного отсека',
    '车架号': 'Идентификационный номер кузова (VIN)',
    '右前减震器支座': 'Правая передняя опора амортизатора',
    '右前翼子板骨架': 'Правая передняя арка крыла',
    '右前纵梁': 'Правая передняя лонжерон',
    '发动机变速箱及附件': 'Двигатель, коробка передач и навесное',
    '机油': 'Моторное масло',
    '防冻液': 'Охлаждающая жидкость',
    '刹车油': 'Тормозная жидкость',
    '电池': 'Аккумулятор',
    '皮带': 'Ремень',
    '保险丝盒': 'Блок предохранителей',
    '发动机线束': 'Жгут проводов двигателя',
    '左前轮胎': 'Левая передняя шина',
    '左前轮毂': 'Левый передний диск колеса',
    '左前避震器': 'Левая передняя амортизационная стойка',
    '左前轮内衬罩': 'Левый передний подкрылок',
    '左前翼子板': 'Левое переднее крыло',
    '左后视镜': 'Левое боковое зеркало',
    '前风挡玻璃': 'Переднее ветровое стекло',
    '左A柱外侧': 'Левая стойка A снаружи',
    '左前车顶': 'Левая передняя часть крыши',
    '左前门玻璃': 'Стекло левой передней двери',
    '左前门外侧': 'Наружная панель левой передней двери',
    '左前门裙边外侧': 'Наружный порог левой передней двери',
    '左前门内侧': 'Внутренняя панель левой передней двери',
    '左前门内饰（含胶条）': 'Обивка левой передней двери (вкл. уплотнители)',
    '左A柱内侧': 'Левая стойка A изнутри',
    '左前门裙边内侧': 'Внутренний порог левой передней двери',
    '主驾座椅区域': 'Зона сиденья водителя',
    '主驾座椅滑轨': 'Салазки сиденья водителя',
    '主驾安全带': 'Ремень безопасности водителя',
    '左前地毯（含周边饰条、饰板）': 'Левый передний ковёр (вкл. молдинги и панели)',
    '转向管柱': 'Рулевая колонка',
    '方向盘': 'Рулевое колесо',
    '仪表盘': 'Панель приборов',
    '中控台': 'Центральная консоль',
    '前排扶手区域': 'Зона переднего подлокотника',
    '主驾仪表台': 'Приборная панель водителя',
    '左A柱内饰板': 'Облицовка левой стойки A',
    '左前顶棚（含前排天窗饰板、遮阳板）': 'Левый передний потолок (вкл. облицовку люка и солнцезащитные козырьки)',
    '前排天窗': 'Передний люк',
    '内后视镜区域': 'Зона зеркала заднего вида',
    '左后轮胎': 'Левая задняя шина',
    '左后轮毂': 'Левый задний диск колеса',
    '左后避震器': 'Левая задняя амортизационная стойка',
    '左后轮内衬罩': 'Левый задний подкрылок',
    '左后翼子板': 'Левое заднее крыло',
    '左C柱外侧': 'Левая стойка C снаружи',
    '左后车顶': 'Левая задняя часть крыши',
    '左B柱外侧': 'Левая стойка B снаружи',
    '左后门玻璃': 'Стекло левой задней двери',
    '左后门外侧': 'Наружная панель левой задней двери',
    '左后门裙边外侧': 'Наружный порог левой задней двери',
    '左后门内侧': 'Внутренняя панель левой задней двери',
    '左后门内饰（含胶条）': 'Обивка левой задней двери (вкл. уплотнители)',
    '左C柱内侧': 'Левая стойка C изнутри',
    '左B柱内侧': 'Левая стойка B изнутри',
    '左后门裙边内侧': 'Внутренний порог левой задней двери',
    '左后座椅区域': 'Зона левого заднего сиденья',
    '左后座椅滑轨': 'Салазки левого заднего сиденья',
    '左后安全带': 'Ремень безопасности левого заднего сиденья',
    '左后地毯（含周边饰条、饰板）': 'Левый задний ковёр (вкл. молдинги и панели)',
    '后排扶手区域': 'Зона заднего подлокотника',
    '左B柱内饰板': 'Облицовка левой стойки B',
    '左C柱内饰板': 'Облицовка левой стойки C',
    '左后顶棚（含后排天窗饰板）': 'Левый задний потолок (вкл. облицовку люка)',
    '后排天窗': 'Задний люк',
    '后风挡玻璃': 'Заднее ветровое стекло',
    '左D柱外侧': 'Левая стойка D снаружи',
    '右D柱外侧': 'Правая стойка D снаружи',
    '后备箱盖外侧': 'Наружная панель крышки багажника',
    '左后尾灯': 'Левый задний фонарь',
    '右后尾灯': 'Правый задний фонарь',
    '后保险杠': 'Задний бампер',
    '后防撞梁': 'Задняя балка бампера',
    '左后纵梁': 'Левая задняя лонжерон',
    '右后纵梁': 'Правая задняя лонжерон',
    '后底盘': 'Заднее днище',
    '后备箱盖内侧': 'Внутренняя панель крышки багажника',
    '后备箱盖内饰板（含胶条）': 'Облицовка крышки багажника (вкл. уплотнители)',
    '后部导水槽': 'Задний водосливной жёлоб',
    '左D柱内饰板': 'Облицовка левой стойки D',
    '左D柱内侧': 'Левая стойка D изнутри',
    '右D柱内饰板': 'Облицовка правой стойки D',
    '右D柱内侧': 'Правая стойка D изнутри',
    '后窗台板': 'Задняя полка',
    '后备箱内饰（含胶条、地毯、周边饰条、饰板）': 'Обивка багажника (вкл. уплотнители, ковёр и молдинги)',
    '后围板': 'Задняя панель кузова',
    '备胎轮胎': 'Запасная шина',
    '备胎轮毂': 'Запасной диск колеса',
    '工具': 'Инструмент',
    '后备箱底板': 'Пол багажника',
    '左后翼子板骨架(包含减震器支座)': 'Левая задняя арка крыла (вкл. опору амортизатора)',
    '右后翼子板骨架(包含减震器支座)': 'Правая задняя арка крыла (вкл. опору амортизатора)',
    '右后轮胎': 'Правая задняя шина',
    '右后轮毂': 'Правый задний диск колеса',
    '右后避震器': 'Правая задняя амортизационная стойка',
    '右后轮内衬罩': 'Правый задний подкрылок',
    '右后翼子板': 'Правое заднее крыло',
    '右C柱外侧': 'Правая стойка C снаружи',
    '右后车顶': 'Правая задняя часть крыши',
    '右B柱外侧': 'Правая стойка B снаружи',
    '右后门玻璃': 'Стекло правой задней двери',
    '右后门外侧': 'Наружная панель правой задней двери',
    '右后门裙边外侧': 'Наружный порог правой задней двери',
    '右后门内侧': 'Внутренняя панель правой задней двери',
    '右后门内饰（含胶条）': 'Обивка правой задней двери (вкл. уплотнители)',
    '右C柱内侧': 'Правая стойка C изнутри',
    '右B柱内侧': 'Правая стойка B изнутри',
    '右后门裙边内侧': 'Внутренний порог правой задней двери',
    '右后座椅区域': 'Зона правого заднего сиденья',
    '右后座椅滑轨': 'Салазки правого заднего сиденья',
    '右后安全带': 'Ремень безопасности правого заднего сиденья',
    '右后地毯（含周边饰条、饰板）': 'Правый задний ковёр (вкл. молдинги и панели)',
    '右B柱内饰板': 'Облицовка правой стойки B',
    '右C柱内饰板': 'Облицовка правой стойки C',
    '右后顶棚': 'Правый задний потолок',
    '右A柱外侧': 'Правая стойка A снаружи',
    '右前车顶': 'Правая передняя часть крыши',
    '右前门玻璃': 'Стекло правой передней двери',
    '右前门外侧': 'Наружная панель правой передней двери',
    '右前门裙边外侧': 'Наружный порог правой передней двери',
    '右前门内侧': 'Внутренняя панель правой передней двери',
    '右前门内饰（含胶条）': 'Обивка правой передней двери (вкл. уплотнители)',
    '右A柱内侧': 'Правая стойка A изнутри',
    '右前门裙边内侧': 'Внутренний порог правой передней двери',
    '副驾座椅区域': 'Зона сиденья пассажира',
    '副驾座椅滑轨': 'Салазки сиденья пассажира',
    '副驾安全带': 'Ремень безопасности пассажира',
    '右前地毯（含周边饰条、饰板）': 'Правый передний ковёр (вкл. молдинги и панели)',
    '副驾仪表台': 'Приборная панель пассажира',
    '右A柱内饰板': 'Облицовка правой стойки A',
    '杂物箱': 'Вещевой ящик',
    '右前顶棚（含前排天窗饰板、遮阳板）': 'Правый передний потолок (вкл. облицовку люка и солнцезащитные козырьки)',
    '右前轮胎': 'Правая передняя шина',
    '右前轮毂': 'Правый передний диск колеса',
    '右前避震器': 'Правая передняя амортизационная стойка',
    '右前轮内衬罩': 'Правый передний подкрылок',
    '右前翼子板': 'Правое переднее крыло',
    '右后视镜': 'Правое боковое зеркало',
    '右前大灯': 'Правая передняя фара',
    '右前雾灯': 'Правая передняя противотуманная фара',
    '启动': 'Запуск',
    '变速箱': 'Коробка передач',
    '排烟': 'Выхлопные газы',
    '无钥匙进入': 'Бесключевой доступ',
    '仪表盘功能自检': 'Самодиагностика панели приборов',
    '转向助力': 'Усилитель руля',
    '电动后视镜功能': 'Функция электрозеркал',
    '中控锁': 'Центральный замок',
    '电动吸合门': 'Доводчик дверей',
    '电动座椅': 'Электропривод сидений',
    '座椅记忆': 'Память сиденья',
    '座椅加热': 'Подогрев сидений',
    '座椅通风': 'Вентиляция сидений',
    '座椅按摩': 'Массаж сидений',
    '主驾驶电动门窗总控': 'Главный пульт электростеклоподъёмников водителя',
    '灯光系统': 'Система освещения',
    '前驻车雷达': 'Передний парктроник',
    '后驻车雷达': 'Задний парктроник',
    '倒车影像': 'Камера заднего вида',
    '全景摄像头': 'Камера кругового обзора',
    '可变悬架': 'Адаптивная подвеска',
    '车载冰箱': 'Автомобильный холодильник',
    '室内灯': 'Освещение салона',
    '天窗': 'Люк',
    '雨刷': 'Стеклоочистители',
    '多功能方向盘': 'Многофункциональное рулевое колесо',
    '方向盘换挡拨片': 'Лепестки переключения передач',
    '方向盘加热': 'Подогрев рулевого колеса',
    '方向盘记忆': 'Память положения рулевого колеса',
    '空调': 'Кондиционер',
    '电动门': 'Электропривод дверей',
    '电动车窗': 'Электростеклоподъёмники',
    '后排电动遮阳帘': 'Задняя электрошторка',
    '后排液晶屏': 'Задний жидкокристаллический экран',
    '玻璃顶电动饰板': 'Электрооблицовка стеклянной крыши',
    '硬顶敞篷': 'Жёсткий складной верх',
    '发动机': 'Двигатель',
    '多媒体系统': 'Мультимедийная система',
    '动力电池包安装点': 'Точки крепления тяговой батареи',
    '动力电池包': 'Тяговая батарея',
    '驱动电机(可见部分)': 'Тяговый электродвигатель (видимая часть)',
    '逆变器(可见部分)': 'Инвертор (видимая часть)',
    '车身高压线束(可见部分)': 'Высоковольтный жгут кузова (видимая часть)',
    '随车充电枪': 'Переносное зарядное устройство',
    '车辆充电口': 'Зарядный разъём автомобиля',
    '增程器': 'Удлинитель запаса хода',
    '动力系统故障码': 'Код неисправности силовой установки',
    '车辆充电故障': 'Неисправность зарядки автомобиля',
  },

  // 缺陷名称
  defect: {
    '安装不良': 'Плохая установка',
    '常转': 'Постоянная работа',
    '超出上限': 'Выше верхнего предела',
    '闯档': 'Рывки при переключении',
    '篡改': 'Вмешательство',
    '打齿异响': 'Скрежет зубчатого зацепления',
    '打滑': 'Пробуксовка',
    '打磨': 'Шлифовка',
    '灯内异物': 'Посторонний предмет в фаре',
    '低于下限': 'Ниже нижнего предела',
    '断裂': 'Излом',
    '钣金修复': 'Кузовной ремонт',
    '改装': 'Тюнинг',
    '更换': 'Замена',
    '功能失效': 'Не функционирует',
    '鼓包': 'Вздутие',
    '故障': 'Неисправность',
    '后打胶': 'Повторное нанесение герметика сзади',
    '花屏': 'Искажение изображения экрана',
    '划痕': 'Царапина',
    '划伤': 'Порез/задир',
    '晃动': 'Люфт/качание',
    '变形': 'Деформация',
    '浑浊': 'Мутная жидкость',
    '胶套损坏': 'Повреждение пыльника',
    '胶体异常': 'Аномалия герметика',
    '胶条异常': 'Аномалия уплотнителя',
    '卡滞': 'Заедание',
    '空转': 'Холостое вращение',
    '老化': 'Старение',
    '裂纹': 'Трещина',
    '冒白烟': 'Белый дым',
    '冒黑烟': 'Чёрный дым',
    '不出风': 'Нет подачи воздуха',
    '冒蓝烟': 'Синий дым',
    '霉斑': 'Плесень',
    '磨损': 'Износ',
    '泥沙': 'Грязь и ил',
    '喷漆': 'Покраска',
    '偏磨': 'Неравномерный износ',
    '破裂': 'Разрыв',
    '破损': 'Повреждение',
    '启动困难': 'Трудный запуск',
    '气囊爆裂': 'Срабатывание подушки безопасности',
    '不跳档': 'Не переключает передачи',
    '切割': 'Разрез',
    '缺失': 'Отсутствие детали',
    '缺损': 'Скол',
    '缺线': 'Отсутствие проводки',
    '入档困难': 'Трудное включение передачи',
    '色差': 'Цветовое различие',
    '烧烫': 'Ожог/прожог',
    '渗水': 'Протечка воды',
    '渗油': 'Подтекание масла',
    '失效': 'Отказ функции',
    '不制冷': 'Не охлаждает',
    '水雾': 'Запотевание',
    '松动': 'Ослабление',
    '松旷': 'Чрезмерный люфт',
    '损坏': 'Поломка',
    '损伤': 'Повреждённое место',
    '塌陷': 'Проседание',
    '调节失效': 'Отказ регулировки',
    '贴膜起泡': 'Пузыри плёнки',
    '脱档': 'Выбивание передачи',
    '污渍': 'Пятна',
    '不走车': 'Автомобиль не движется',
    '响应慢': 'Медленный отклик',
    '修复': 'Ремонт',
    '锈蚀': 'Коррозия',
    '异味': 'Запах',
    '异响': 'Посторонний шум',
    '怠速不稳': 'Неустойчивые обороты холостого хода',
    '怠速过高': 'Повышенные обороты холостого хода',
    '给不上油': 'Нет подачи топлива',
    '加速抖动': 'Вибрация при разгоне',
    '缺缸': 'Пропуск зажигания цилиндра',
    '部件缺失': 'Отсутствие деталей',
    '气门异响': 'Шум клапанов',
    '内部异响': 'Внутренний шум',
    '轮组异响': 'Шум колёсного узла',
    '窜气': 'Прорыв газов',
    '排气异响': 'Шум выхлопа',
    '水渍': 'Водяное пятно',
    '凹陷': 'Вмятина',
    '车门更换': 'Замена двери',
    '拆卸': 'Демонтаж',
    '后盖更换': 'Замена крышки багажника',
    '机盖更换': 'Замена капота',
    '内饰更换': 'Замена салона',
    '焊接': 'Сварка',
    '开裂': 'Растрескивание',
    '剐蹭划伤': 'Задиры и царапины',
    '渗漏': 'Протечка',
    '火烧': 'Возгорание',
    '抖动': 'Вибрация/дрожание',
    '动力电池故障': 'Неисправность тяговой батареи',
    '驱动电机故障': 'Неисправность тягового электродвигателя',
    '其他': 'Прочее',
    '快充故障': 'Неисправность быстрой зарядки',
    '慢充故障': 'Неисправность медленной зарядки',
    '过火': 'Следы возгорания',
    '缺气': 'Недостаточное давление воздуха',
  },

  // 等级
  grade: {
    'A': 'Класс A',
    'B': 'Класс B',
    'C': 'Класс C',
    'D': 'Класс D',
  },

  // 综合描述模板关键词
  description: {
    '外观无换件': 'Заменённых внешних деталей нет',
    '外观原漆': 'Заводская окраска',
    '外观无需整备成本': 'Без затрат на восстановление экстерьера',
    '内饰正常使用痕迹': 'Естественные следы эксплуатации салона',
    '车辆无骨架损伤': 'Повреждений силового каркаса нет',
    '发动机工况无异常': 'Двигатель работает нормально',
    '变速器原地试车无异常': 'Коробка передач при испытании на месте без отклонений',
  },

  // 通用
  common: {
    '项': 'пункт',
    '项异常': 'пунктов с отклонениями',
    '分': 'балл',
    '级': 'Класс',
    '检测': 'Осмотр',
    '图片': 'Изображение',
    '加载失败': 'Не удалось загрузить',
    '加载中...': 'Загрузка...',
  },

  // 页面标题
  title: {
    '车况检测': 'Проверка состояния автомобиля',
    '综合描述': 'Общее описание',
    '综合': 'Общий',
  },

  // 提示文案
  tips: {
    '源于出险数据': '(Из данных страховых случаев)',
    '车辆是否曾进水(漏水/涉水/水泡)': 'Был ли автомобиль когда-либо затоплен (протечка/преодоление воды/утонувший)?',
    '是': 'Да',
    '否': 'Нет',
    '查看原图': 'Смотреть оригинал',
  },

  // 评分规则标题
  ruleTitle: {
    '外观评分规则': 'Правила оценки внешнего вида',
    '骨架评级规则': 'Правила оценки каркаса',
    '内饰评分规则': 'Правила оценки салона',
    '综合评级规则': 'Правила комплексной оценки',
  },

  // 外观评分说明
  exteriorRule: {
    '外观准新': 'Состояние кузова как новый',
    '外观较好': 'Хорошее состояние кузова',
    '外观一般': 'Среднее состояние кузова',
    '外观较差': 'Плохое состояние кузова',
    '外观极差': 'Очень плохое состояние кузова',
  },

  // 内饰评分说明
  interiorRule: {
    '内饰准新': 'Состояние салона как новый',
    '内饰较好': 'Хорошее состояние салона',
    '内饰一般': 'Среднее состояние салона',
    '内饰较差': 'Плохое состояние салона',
    '内饰极差': 'Очень плохое состояние салона',
  },

  // 骨架评级说明
  skeletonRule: {
    '车辆结构件与加强件均无因事故造成的损伤': 'Отсутствуют повреждения силовых и усилительных элементов кузова, вызванные ДТП.',
    '车辆结构件无因事故造成的损伤，车辆加强件有因事故造成的轻微损伤': 'Силовые элементы кузова без повреждений от ДТП; усилительные элементы имеют незначительные повреждения от ДТП.',
    '车辆结构件无因事故造成的损伤，车辆加强件有因事故造成的严重损伤': 'Силовые элементы кузова без повреждений от ДТП; усилительные элементы имеют значительные повреждения от ДТП.',
    '车辆结构件有因事故造成的损伤': 'Имеются повреждения силовых элементов кузова, вызванные ДТП.',
  },

  // 综合评级说明
  overallRule: {
    '骨架等级≥A，外观评分≥90，内饰评分≥90，不可出现更换，切割，锈蚀，泥沙，水渍，部件缺失，霉斑，烧烫和机电模块损伤。': 'Каркас категории ≥A, оценка внешнего вида ≥90, оценка салона ≥90; не допускаются замена, резка, коррозия, грязь, следы воды, отсутствующие детали, плесень, следы ожогов и повреждения электромеханических модулей.',
    '骨架等级≥A，外观评分≥80，内饰评分≥80，不可出现切割，泥沙，水渍，霉斑，锈蚀等损伤。': 'Каркас категории ≥A, оценка внешнего вида ≥80, оценка салона ≥80; не допускаются резка, грязь, следы воды, плесень, коррозия и другие повреждения.',
    '骨架等级≥B，外观评分＞40，内饰评分＞40': 'Каркас категории ≥B, оценка внешнего вида >40, оценка салона >40',
    '骨架等级≥C，外观评分≥70，内饰评分≥70': 'Каркас категории ≥C, оценка внешнего вида ≥70, оценка салона ≥70',
    '骨架等级≥D，外观评分≥60，内饰评分≥50': 'Каркас категории ≥D, оценка внешнего вида ≥60, оценка салона ≥50',
    '骨架等级≥D，外观评分≥50，内饰评分≥40，不可勾选水泡车。': 'Каркас категории ≥D, оценка внешнего вида ≥50, оценка салона ≥40; отметка «утонувший автомобиль» не допускается.',
    '骨架等级≥D，外观评分<50，内饰评分<40': 'Каркас категории ≥D, оценка внешнего вида <50, оценка салона <40',
  }
}
